// src/lib/auth.js

const TOKEN_KEY = 'authToken';

export const setAuthToken = (token) => {
  sessionStorage.setItem(TOKEN_KEY, token);
};

export const getAuthToken = () => {
  return sessionStorage.getItem(TOKEN_KEY);
};

export const clearAuthToken = () => {
  sessionStorage.removeItem(TOKEN_KEY);
};

export const logout = () => {
  clearAuthToken();
  // Force a full page reload to clear all state and redirect to login
  window.location.href = '/account'; 
};
